import React from "react";
import classnames from "classnames";
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  Nav,
  Container,
} from "reactstrap";
import { NavLink as Link, Navigate } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import { setToken } from "action/index.js";
import API from "api.js";
const mapStateToProps = (state) => {
  return {
    token: state.token,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setToken: (tok) => dispatch(setToken(tok)),
  };
};
class AdminNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      color: "navbar-transparent",
      logout: false,
      first_name: null,
      last_name: null,
      country_citizenship: null,
      country_residence: null,
      dob: null,
      email: null,
      image: null,
      phone: null,
      address: null,
      lang: null,
      center: null,
      score: null,
      listening: null,
      exam_date: null,
      overall_score: null,
      institute: null,
      modal: false,
      dashboard: false,
    };
  }

  closeModal = (e) => {
    e.preventDefault();
    this.setState({ modal: false });
  };

  componentDidMount() {
    API({
      method: "GET",
      url: "dashboard/data",
    })
      .then((data) => {
        var first_name = data.data.user_data.first_name;
        var last_name = data.data.user_data.last_name;
        var country_citizenship = data.data.user_data.country_citizenship;
        var country_residence = data.data.user_data.country_residence;
        var country_state = data.data.user_data.country_state;
        var dob = data.data.user_data.dob;
        var email = data.data.user_data.email;
        var image = data.data.user_data.image;
        var phone = data.data.user_data.phone;
        var address = data.data.user_data.address;
        var lang = data.data.user_data.lang;
        var center = data.data.user_data.center;
        var score = data.data.user_data.score;
        var listening = data.data.user_data.listening;
        var institute = data.data.user_data.institute;
        var exam_date = data.data.user_data.exam_date;
        var speaking = data.data.user_data.speaking;
        var reading = data.data.user_data.reading;
        var writing = data.data.user_data.writing;
        var listening = data.data.user_data.listening;
        var overall_score = (speaking + reading + writing + listening) / 4;
        this.setState({
          first_name: first_name,
          last_name: last_name,
          country_citizenship: country_citizenship,
          country_residence: country_residence,
          country_state: country_state,
          dob: dob,
          email: email,
          image: image,
          phone: phone,
          address: address,
          lang: lang,
          center: center,
          score: score,
          listening: listening,
          exam_date: exam_date,
          overall_score: overall_score,
          institute: institute,
        });

        if (window.location.pathname.match("profile") && this.state.modal) {
          this.setState({ modal: false });
        }
        if (
          !this.state.institute &&
          !window.location.pathname.match("profile") &&
          !window.location.pathname.match("sub/subscription") &&
          !this.state.modal &&
          (this.state.center == null ||
            !this.state.phone ||
            !this.state.email ||
            !this.state.country_residence ||
            !this.state.country_state ||
            !this.state.country_citizenship)
        ) {
          this.setState({ modal: true });
        }

        // if (!window.location.pathname.match('profile') && !window.location.pathname.match('sub/subscription') && !this.state.modal && (this.state.score == null || this.state.score == 'null' || this.state.center == 'null' || this.state.center == null || !this.state.lang || !this.state.phone || !this.state.email || !this.state.country_residence|| !this.state.country_state || !this.state.dob || !this.state.country_citizenship)) {
        //   this.setState({modal:true});
        // }
      })
      .catch(() => {});
    window.addEventListener("resize", this.updateColor);
  }
  componentDidUpdate(e) {
    if (
      window.outerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
  }
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor = () => {
    if (window.innerWidth < 993 && this.state.collapseOpen) {
      this.setState({
        color: "bg-white",
      });
    } else {
      this.setState({
        color: "navbar-transparent",
      });
    }
  };

  openDashboard = () => {
    this.setState({ dashboard: true });
  };
  // this function opens and closes the sidebar on small devices
  toggleSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
  };
  // this function opens and closes the collapse on small devices
  // it also adds navbar-transparent class to the navbar when closed
  // ad bg-white when opened
  toggleCollapse = () => {
    let newState = {
      collapseOpen: !this.state.collapseOpen,
    };
    if (!this.state.collapseOpen) {
      newState["color"] = "bg-white";
    } else {
      newState["color"] = "navbar-transparent";
    }
    this.setState(newState);
  };
  logout = () => {
    cookie.remove("access-token", { path: "/" });
    this.setState({ logout: true });
  };
  render() {
    if (this.state.dashboard) {
      return <Navigate to="/video-courses" replace />;
    }

    if (this.state.logout) {
      this.props.setToken(null);
      return <Navigate to="/auth/login" replace />;
    }

    return (
      <>
        {/* {this.state.modal && <Modal isOpen={this.state.modal} size="md">
        <div className="modalHeader">
          <h2> Please complete your details</h2>
          <a
            onClick={this.closeModal.bind(this)}
            style={{
              color: "#93c13e",
              opacity: "unset",
              position: "absolute",
              top: "8%",
              right: "3%",
            }}
            href="#"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </a>
        </div>
        <ModalBody>
          <Row>
            <Col md={12}>
              
            </Col> 
          </Row>
        </ModalBody>
        <ModalFooter>
          <Link to="/admin/profile" ><Button color="secondary" className="modalCloseBtn" >Complete Profile</Button></Link>
          
        </ModalFooter>
      </Modal>} */}
        <Navbar
          className={classnames("navbar-absolute fixed-top", this.state.color)}
          expand="lg"
        >
          <Container fluid>
            <div className="navbar-wrapper">
              <div className="navbar-minimize">
                <Button
                  className="btn-icon btn-round"
                  color="default"
                  onClick={() => {
                    this.openDashboard();
                  }}
                >
                  <i className="nc-icon nc-minimal-right text-center visible-on-sidebar-mini" />
                  <i className="nc-icon nc-minimal-left text-center visible-on-sidebar-regular" />
                </Button>
              </div>
              <div
                className={classnames("navbar-toggle", {
                  toggled: this.state.sidebarOpen,
                })}
              >
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={this.toggleSidebar}
                >
                  <span className="navbar-toggler-bar bar1" />
                  <span className="navbar-toggler-bar bar2" />
                  <span className="navbar-toggler-bar bar3" />
                </button>
              </div>
              <NavbarBrand href="#pablo" onClick={(e) => e.preventDefault()}>
                <span className="d-none d-md-block"></span>
                <span className="d-block d-md-none"></span>
              </NavbarBrand>
            </div>
            <button
              aria-controls="navigation-index"
              aria-expanded={this.state.collapseOpen}
              aria-label="Toggle navigation"
              className="navbar-toggler"
              // data-target="#navigation"
              data-toggle="collapse"
              type="button"
              onClick={this.toggleCollapse}
            >
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
            </button>
            <Collapse
              className="justify-content-end"
              navbar
              isOpen={this.state.collapseOpen}
            >
              <Nav navbar>
                <UncontrolledDropdown className="btn-rotate" nav>
                  <DropdownToggle
                    aria-haspopup={true}
                    caret
                    color="default"
                    data-toggle="dropdown"
                    id="navbarDropdownMenuLink"
                    nav
                  >
                    <i className="nc-icon nc-single-02" />
                  </DropdownToggle>
                  <DropdownMenu aria-labelledby="navbarDropdownMenuLink" right>
                    <Link to="/admin/profile">
                      <DropdownItem>My Profile</DropdownItem>
                    </Link>
                    <Link to="/admin/password">
                      <DropdownItem>Change Password</DropdownItem>
                    </Link>
                    <DropdownItem onClick={this.logout}>Logout</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminNavbar);

{
  /* {this.state.modal && <Modal isOpen={this.state.modal} size="md">
        <div className="modalHeader">
          <h2> Please complete your details</h2>
          <a
            onClick={this.closeModal.bind(this)}
            style={{
              color: "#93c13e",
              opacity: "unset",
              position: "absolute",
              top: "8%",
              right: "3%",
            }}
            href="#"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </a>
        </div>
        <ModalBody>
          <Row>
            <Col md={12}>
              
            </Col> 
          </Row>
        </ModalBody>
        <ModalFooter>
          <Link to="/admin/profile" ><Button color="secondary" className="modalCloseBtn" >Complete Profile</Button></Link>
          
        </ModalFooter>
      </Modal>} */
}
